var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessThanIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0.608689 16.5206C0.219425 16.1751 0.000484328 15.7062 0 15.2172V14.2828C0.00637465 13.7948 0.224429 13.3279 0.608689 12.9794L14.8299 0.363713C15.0896 0.130934 15.4432 0 15.8121 0C16.1809 0 16.5345 0.130934 16.7943 0.363713L18.7587 2.10974C19.0189 2.33639 19.1656 2.64661 19.1656 2.97046C19.1656 3.29431 19.0189 3.60453 18.7587 3.83118L6.44657 14.75L18.7587 25.6688C19.0206 25.8997 19.1679 26.214 19.1679 26.5418C19.1679 26.8697 19.0206 27.184 18.7587 27.4149L16.7943 29.1363C16.5345 29.3691 16.1809 29.5 15.8121 29.5C15.4432 29.5 15.0896 29.3691 14.8299 29.1363L0.608689 16.5206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThanIcon);
export default __webpack_public_path__ + "static/media/LessThanIcon.cb41e3853f678e1f178833b785e63517.svg";
export { ForwardRef as ReactComponent };